module.exports = __webpack_public_path__ + "img/directory.86f087ca.svg";